module.exports = __webpack_public_path__ + "img/bookmark.f9eba793.svg";